import { Node } from '../Node';
import { NodeModelTypeEnum } from '../enums';

export class AirTemperatureSensorNodeModel extends Node {
  constructor(device, options = {}) {
    super({
      device,
      options,
      type: NodeModelTypeEnum.AirTemperatureSensor,
    });
  }
}
